import { Controller } from 'stimulus';
// @ts-ignore
import PinyinConverter from '../../vendor/pinyin_converter';
import { ChangeEvent } from 'react';

export default class PinyinInputController extends Controller {
  connect() {
    const $elm = $(this.element);
    ($elm as any).on('input', (evt: ChangeEvent<HTMLInputElement>) => {
      $elm.val(PinyinConverter.convert(evt.target.value));
    });
  }
}
